/* eslint no-param-reassign: 0 */

export const CELLPHONE_RECOVERY_STORE_NAMESPACE = 'cellphone_recovery';

export const MUTATION_UPDATE_CELLPHONE_RECOVERY_SETTINGS = 'updateCellphoneRecoverySettings';
export const MUTATION_UPDATE_COUNTRY_SELECT_OPTIONS = 'updateCountrySelectOptions';
export const GETTER_SHOW_EXTERNAL_WARNING = 'showExternalsWarning';

const store = {
    namespaced: true,
    state: {
        updateUserInfo: false,
        showSmsDialog: false,
        showPhoneDialog: false,
        emailConfirmed: false,
        showResetExternalsWarning: false,
        hasExternals: false,
        operationVerified: false,
        CountrySelectOptions: [],
        MinLength: 0,
        MaxLength: 0,
        riddlerFeature: '',
        riddlerDefaultType: '',
        urls: {},
        phoneConfirmed: false,
        cellphone: '',
        codeLifetime: '',
        smsMaxAttempts: '',
        codeLength: '',
        countryCodeByIp: null,
    },

    mutations: {
        [MUTATION_UPDATE_CELLPHONE_RECOVERY_SETTINGS](state, newState) {
            if (!newState) {
                console.log('No new state provided');
                return;
            }

            // Обновляем только те поля, которые есть в state
            Object.keys(newState).forEach(key => {
                if (key in state) {
                    const newValue = newState[key];

                    state[key] = newValue;
                } else {
                    console.log(`Ключ ${key} не существует в state.`);
                }
            });
        },
        [MUTATION_UPDATE_COUNTRY_SELECT_OPTIONS](state, options) {
            if (!options) return;
            state.CountrySelectOptions = options;
        },
    },
    getters: {
        // eslint-disable-next-line max-len
        [GETTER_SHOW_EXTERNAL_WARNING]: state => state.showResetExternalsWarning && state.hasExternals,
    },
};

if (window.App && window.App.store) {
    window.App.store.registerModule(CELLPHONE_RECOVERY_STORE_NAMESPACE, store);
}

export default store;
